














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AppleLogo extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
}
